<template>
  <div class="flex items-center justify-start">
    <input
      :id="`single-${id}`"
      v-model="checkboxVal"
      :value="value"
      type="checkbox"
      class="hidden h-5 w-5 border-cdp-grey-400 accent-cdp-main-primary duration-300"
      :disabled="disabled"
    />
    <label
      :for="`single-${id}`"
      class="mx-2 flex items-center gap-2 text-sm font-normal text-cdp-black-500"
    >
      <icon
        v-show="checkboxVal && !disabled"
        name="ic_checkbox_checked_normal"
        class="h-6 w-6 text-cdp-white"
      />
      <icon
        v-show="checkboxVal && disabled"
        name="ic_checkbox_checked_disable"
        class="h-6 w-6 text-cdp-grey-100"
      />
      <icon
        v-show="!checkboxVal && !disabled"
        name="ic_checkbox_uncheck_normal"
        class="h-6 w-6 text-cdp-grey-300"
      />
      <icon
        v-show="!checkboxVal && disabled"
        name="ic_checkbox_uncheck_disable"
        class="h-6 w-6 text-cdp-grey-400"
      />

      <slot name="text">
        {{ text }}
      </slot>
    </label>
  </div>
</template>

<script>
import { computed, defineComponent } from 'vue';
export default defineComponent({
  /**
   * 最初註冊名稱與檔案名稱開頭大小寫不一致，故針對此命名（Histoire 讀檔用）
   */
  name: 'Checkbox',
  props: {
    modelValue: {
      type: [Boolean, Array],
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number],
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const checkboxVal = computed({
      get: () => props.modelValue,
      set: (val) => {
        emit('update:modelValue', val);
      }
    });

    return {
      checkboxVal
    };
  }
});
</script>